// src/components/Profile/OrderTimelineModal.jsx
import React from 'react';

export default function OrderTimelineModal({ order, isOpen, onClose, statusSteps }) {
  if (!isOpen) return null;

  const iconColors = {
    green: '#2dd36f',
    blue: '#694cff',
    teal: '#19acb2',
    purple: '#9c27b0',
    orange: '#ffb566',
    cyan: '#00bcd4',
    amber: '#ffc107',
    red: '#ed4b4b'
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(54,56,99,0.14)',
        zIndex: 1500,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 15,
          maxWidth: 420,
          width: '97vw',
          minWidth: 310,
          minHeight: 340,
          padding: '0 0 24px 0',
          boxShadow: '0 8px 32px rgba(120,80,255,0.15)',
          position: 'relative',
          overflow: 'hidden'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '25px 28px 10px 28px',
            background: '#f6f3ff',
            borderRadius: '14px 14px 0 0',
            boxShadow: '0 2px 8px rgba(77,65,145,0.04)'
          }}
        >
          <div>
            <span
              style={{
                fontSize: 19.5,
                fontWeight: 700,
                color: '#5237ce',
                marginRight: 10
              }}
            >
              Order Timeline
            </span>
            <span
              style={{
                fontSize: 13,
                color: '#7576bb',
                fontFamily: 'Consolas, Inter, Courier New, monospace'
              }}
            >
              #{order.order_number}
            </span>
          </div>
          <button
            style={{
              background: 'none',
              border: 'none',
              fontSize: 22,
              color: '#786cff',
              cursor: 'pointer',
              transition: 'color 0.13s'
            }}
            onClick={onClose}
          >
            <i className="ph ph-x"></i>
          </button>
        </div>

        {/* Timeline List */}
        <div style={{ position: 'relative', padding: '17px 22px 0 38px', maxHeight: 420, overflowY: 'auto' }}>
          {statusSteps.map((step, idx) => {
            const date = order[step.key];
            const isCompleted = !!date;
            const isCancelled = order.status === 'Cancelled';

            if (step.key === 'cancelled_at' && !isCancelled) return null;

            const nextStep = statusSteps[idx + 1];
            const nextDate = nextStep ? order[nextStep.key] : null;
            const showConnector = isCompleted && nextDate && nextStep?.key !== 'cancelled_at';

            const displayDate = date
              ? new Date(date).toLocaleString('en-US', {
                  weekday: 'short',
                  day: '2-digit',
                  month: 'short',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: true
                })
              : 'Pending';

            return (
              <div
                key={step.key}
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  position: 'relative',
                  marginBottom: 26,
                  minHeight: 38,
                  zIndex: 2,
                  opacity: isCompleted ? 1 : 0.35
                }}
              >
                {/* Icon Container */}
                <div style={{ position: 'relative', marginRight: 13 }}>
                  {/* Icon */}
                  <span
                    style={{
                      width: 32,
                      height: 32,
                      fontSize: 18,
                      borderRadius: '50%',
                      background: isCompleted ? '#fff' : '#f5f5f5',
                      border: `3px solid ${isCompleted ? iconColors[step.color] || '#786cff' : '#ddd'}`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: isCompleted ? iconColors[step.color] || '#786cff' : '#aaa',
                      position: 'relative',
                      zIndex: 3,
                      boxShadow: isCompleted ? '0 2px 8px rgba(120,80,255,0.15)' : 'none'
                    }}
                  >
                    <i className={`ph ${step.icon}`}></i>
                  </span>

                  {/* Connecting Line */}
                  {showConnector && (
                    <div
                      style={{
                        position: 'absolute',
                        left: '50%',
                        top: '32px',
                        transform: 'translateX(-50%)',
                        width: '3px',
                        height: '26px',
                        background: iconColors[step.color] || '#786cff',
                        zIndex: 1
                      }}
                    />
                  )}
                </div>

                {/* Label & Date */}
                <div>
                  <div
                    style={{
                      fontWeight: isCompleted ? 700 : 500,
                      color: isCompleted ? '#5543d2' : '#999',
                      fontSize: 15.3,
                      marginBottom: 3,
                      letterSpacing: 0.1
                    }}
                  >
                    {step.label}
                  </div>
                  <div
                    style={{
                      fontSize: 13.5,
                      color: isCompleted ? '#557' : '#aaa',
                      fontFamily: 'Consolas, Inter, Courier New, monospace',
                      fontWeight: 500
                    }}
                  >
                    {displayDate}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}